import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'ru_RU',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  'eefa0056-d2ce-48d5-a794-207c9c2dddf9',
  ''
);
